export class CustomerList {
    constructor(data) {
        this.id = data?.id ?? null;
        this.name = data?.name ?? "";
        this.address = data?.address ?? "";
        this.latitude = data?.latitude ?? null;
        this.longitude = data?.longitude ?? null;
    }

    getId() {
        return this.id;
    }

    getName() {
        return this.name;
    }

    getAddress() {
        return this.address;
    }

    getLatitude() {
        return this.latitude;
    }

    getLongitude() {
        return this.longitude;
    }
}

export class RestaurantList {
    constructor(data) {
        this.id = data?.id ?? null;
        this.name = data?.name ?? "";
        this.address = data?.address ?? "";
        this.latitude = data?.latitude ?? null;
        this.longitude = data?.longitude ?? null;
    }

    getId() {
        return this.id;
    }

    getName() {
        return this.name;
    }

    getAddress() {
        return this.address;
    }

    getLatitude() {
        return this.latitude;
    }

    getLongitude() {
        return this.longitude;
    }
}

export class OrderList {
    constructor(data) {
        this.orderId = data?.orderId ?? null;
        this.companyId = data?.companyId ?? null;
        this.orderNumber = data?.orderNumber ?? "";
        this.customer = data?.customer ? new CustomerList(data.customer) : null;
        this.restaurant = data?.restaurant ? new RestaurantList(data.restaurant) : null;
        this.assignedCarrierId = data?.assignedCarrierId ?? null;
        this.totalCost = data?.totalCost ?? 0.0;
        this.status = data?.status ?? "";
        this.assignedCarrierName = data?.assignedCarrierName ?? null;
        this.expectedDeliveryDate = data?.expectedDeliveryDate ?? null;
        this.expectedDeliveryTime = data?.expectedDeliveryTime ?? null;
        this.expectedPickupTime = data?.expectedPickupTime ?? null;
    }

    getOrderId() {
        return this.orderId;
    }

    getCompanyId() {
        return this.companyId;
    }

    getOrderNumber() {
        return this.orderNumber;
    }

    getCustomer() {
        return this.customer;
    }

    getRestaurant() {
        return this.restaurant;
    }

    getAssignedCarrierId() {
        return this.assignedCarrierId;
    }

    getTotalCost() {
        return this.totalCost;
    }

    getStatus() {
        return this.status;
    }

    getAssignedCarrierName() {
        return this.assignedCarrierName;
    }

    getExpectedDeliveryDate() {
        return this.expectedDeliveryDate;
    }

    getExpectedDeliveryTime() {
        return this.expectedDeliveryTime;
    }

    getExpectedPickupTime() {
        return this.expectedPickupTime;
    }
}

export class CustomerDetail {
    constructor(data) {
        this.name = data?.name ?? "";
        this.address = data?.address ?? "";
        this.phoneNumber = data?.phoneNumber ?? null;
        this.emails = Array.isArray(data?.emails) ? data.emails : [];
        this.latitude = data?.latitude ?? null;
        this.longitude = data?.longitude ?? null;
    }

    getName() {
        return this.name;
    }

    getAddress() {
        return this.address;
    }

    getPhoneNumber() {
        return this.phoneNumber;
    }

    getEmails() {
        return this.emails;
    }

    getLatitude() {
        return this.latitude;
    }

    getLongitude() {
        return this.longitude;
    }
}

export class RestaurantDetail {
    constructor(data) {
        this.name = data?.name ?? "";
        this.address = data?.address ?? "";
        this.phoneNumber = data?.phoneNumber ?? null;
        this.latitude = data?.latitude ?? null;
        this.longitude = data?.longitude ?? null;
    }

    getName() {
        return this.name;
    }

    getAddress() {
        return this.address;
    }

    getPhoneNumber() {
        return this.phoneNumber;
    }

    getLatitude() {
        return this.latitude;
    }

    getLongitude() {
        return this.longitude;
    }
}

export class AssignedCarrier {
    constructor(data) {
        this.id = data?.id ?? null;
        this.name = data?.name ?? "";
        this.phoneNumber = data?.phoneNumber ?? null;
    }

    getId() {
        return this.id;
    }

    getName() {
        return this.name;
    }

    getPhoneNumber() {
        return this.phoneNumber;
    }
}

export class ActivityLog {
    constructor(data) {
        this.placementTime = data?.placementTime ?? null;
        this.expectedPickupTime = data?.expectedPickupTime ?? null;
        this.expectedDeliveryDate = data?.expectedDeliveryDate ?? null;
        this.expectedDeliveryTime = data?.expectedDeliveryTime ?? null;
        this.assignedTime = data?.assignedTime ?? null;
        this.startTime = data?.startTime ?? null;
        this.pickedUpTime = data?.pickedUpTime ?? null;
        this.arrivedTime = data?.arrivedTime ?? null;
        this.deliveryTime = data?.deliveryTime ?? null;
        this.failedDeliveryTime = data?.failedDeliveryTime ?? null;
    }

    getPlacementTime() {
        return this.placementTime;
    }

    getExpectedPickupTime() {
        return this.expectedPickupTime;
    }

    getExpectedDeliveryDate() {
        return this.expectedDeliveryDate;
    }

    getExpectedDeliveryTime() {
        return this.expectedDeliveryTime;
    }

    getAssignedTime() {
        return this.assignedTime;
    }

    getStartTime() {
        return this.startTime;
    }

    getPickedUpTime() {
        return this.pickedUpTime;
    }

    getArrivedTime() {
        return this.arrivedTime;
    }

    getDeliveryTime() {
        return this.deliveryTime;
    }

    getFailedDeliveryTime() {
        return this.failedDeliveryTime;
    }
}

export class CostInfo {
    constructor(data) {
        this.totalCost = data?.totalCost ?? 0.0;
        this.deliveryFee = data?.deliveryFee ?? 0.0;
        this.tip = data?.tip ?? 0.0;
        this.discountAmount = data?.discountAmount ?? 0.0;
        this.tax = data?.tax ?? 0.0;
        this.serviceFee = data?.serviceFee ?? 0.0;
    }

    getTotalCost() {
        return this.totalCost;
    }

    getDeliveryFee() {
        return this.deliveryFee;
    }

    getTip() {
        return this.tip;
    }

    getDiscountAmount() {
        return this.discountAmount;
    }

    getTax() {
        return this.tax;
    }

    getServiceFee() {
        return this.serviceFee;
    }
}

export class FeedbackInfo {
    constructor(data) {
        this.feedback = data?.feedback ?? null;
        this.feedbackDetails = data?.feedbackDetails ?? "";
    }

    getFeedback() {
        return this.feedback;
    }

    getFeedbackDetails() {
        return this.feedbackDetails;
    }
}

export class StatusFlags {
    constructor(data) {
        this.incomplete = data?.incomplete ?? false;
        this.accepted = data?.accepted ?? false;
        this.thirdPartyAssignedAnytime = data?.thirdPartyAssignedAnytime ?? false;
    }

    getIncomplete() {
        return this.incomplete;
    }

    getAccepted() {
        return this.accepted;
    }

    getThirdPartyAssignedAnytime() {
        return this.thirdPartyAssignedAnytime;
    }
}

export class OrderItem {
    constructor(data) {
        this.name = data?.name ?? "";
        this.quantity = data?.quantity ?? 0;
        this.unitPrice = data?.unitPrice ?? "0";
        this.detail = data?.detail ?? "";
        this.addOns = Array.isArray(data?.addOns) ? data.addOns : [];
    }

    getName() {
        return this.name;
    }

    getQuantity() {
        return this.quantity;
    }

    getUnitPrice() {
        return this.unitPrice;
    }

    getDetail() {
        return this.detail;
    }

    getAddOns() {
        return this.addOns;
    }
}

export class ProofOfDelivery {
    constructor(data) {
        this.signaturePath = data?.signaturePath ?? null;
        this.imageUrls = Array.isArray(data?.imageUrls) ? data.imageUrls : [];
        this.latitude = data?.latitude ?? null;
        this.longitude = data?.longitude ?? null;
    }

    getSignaturePath() {
        return this.signaturePath;
    }

    getImageUrls() {
        return this.imageUrls;
    }

    getLatitude() {
        return this.latitude;
    }

    getLongitude() {
        return this.longitude;
    }
}

export class PaymentInfo {
    constructor(data) {
        this.paymentMethod = data?.paymentMethod ?? null;
        this.creditCardType = data?.creditCardType ?? null;
        this.creditCardId = data?.creditCardId ?? null;
    }

    getPaymentMethod() {
        return this.paymentMethod;
    }

    getCreditCardType() {
        return this.creditCardType;
    }

    getCreditCardId() {
        return this.creditCardId;
    }
}

export class OrderDetail {
    constructor(data) {
        this.orderId = data?.orderId ?? null;
        this.companyId = data?.companyId ?? null;
        this.orderNumber = data?.orderNumber ?? "";
        this.customer = data?.customer ? new CustomerDetail(data.customer) : null;
        this.restaurant = data?.restaurant ? new RestaurantDetail(data.restaurant) : null;
        this.distance = data?.distance ?? 0.0;
        this.parentId = data?.parentId ?? null;
        this.assignedCarrier = data?.assignedCarrier ? new AssignedCarrier(data.assignedCarrier) : null;
        this.activityLog = data?.activityLog ? new ActivityLog(data.activityLog) : null;
        this.costInfo = data?.costInfo ? new CostInfo(data.costInfo) : null;
        this.feedbackInfo = data?.feedbackInfo ? new FeedbackInfo(data.feedbackInfo) : null;
        this.orderStatus = data?.orderStatus ?? "";
        this.statusFlags = data?.statusFlags ? new StatusFlags(data.statusFlags) : null;
        this.thirdPartyInfo = data?.thirdPartyInfo ?? null;
        this.trackingLink = data?.trackingLink ?? null;
        this.orderStatusAdmin = data?.orderStatusAdmin ?? null;
        this.isScheduled = data?.isScheduled ?? false;
        this.isCatering = data?.isCatering ?? false;
        this.thirdPartyAssigned = data?.thirdPartyAssigned ?? false;
        this.orderSeqNum = data?.orderSeqNum ?? null;
        this.dispatcherNotes = data?.dispatcherNotes ?? false;
        this.orderItems = Array.isArray(data?.orderItems) 
            ? data.orderItems.map(item => new OrderItem(item)) 
            : [];
        this.proofOfDelivery = data?.proofOfDelivery ? new ProofOfDelivery(data.proofOfDelivery) : null;
        this.deliveryInstruction = data?.deliveryInstruction ?? "";
        this.deliveryNote = data?.deliveryNote ?? null;
        this.paymentInfo = data?.paymentInfo ? new PaymentInfo(data.paymentInfo) : null;
    }

    getOrderId() {
        return this.orderId;
    }

    getCompanyId() {
        return this.companyId;
    }

    getOrderNumber() {
        return this.orderNumber;
    }

    getCustomer() {
        return this.customer;
    }

    getRestaurant() {
        return this.restaurant;
    }

    getDistance() {
        return this.distance;
    }

    getParentId() {
        return this.parentId;
    }

    getAssignedCarrier() {
        return this.assignedCarrier;
    }

    getActivityLog() {
        return this.activityLog;
    }

    getCostInfo() {
        return this.costInfo;
    }

    getFeedbackInfo() {
        return this.feedbackInfo;
    }

    getOrderStatus() {
        return this.orderStatus;
    }

    getStatusFlags() {
        return this.statusFlags;
    }

    getThirdPartyInfo() {
        return this.thirdPartyInfo;
    }

    getTrackingLink() {
        return this.trackingLink;
    }

    getOrderStatusAdmin() {
        return this.orderStatusAdmin;
    }

    getIsScheduled() {
        return this.isScheduled;
    }

    getIsCatering() {
        return this.isCatering;
    }

    getThirdPartyAssigned() {
        return this.thirdPartyAssigned;
    }

    getOrderSeqNum() {
        return this.orderSeqNum;
    }

    getDispatcherNotes() {
        return this.dispatcherNotes;
    }

    getOrderItems() {
        return this.orderItems;
    }

    getProofOfDelivery() {
        return this.proofOfDelivery;
    }

    getDeliveryInstruction() {
        return this.deliveryInstruction;
    }

    getDeliveryNote() {
        return this.deliveryNote;
    }

    getPaymentInfo() {
        return this.paymentInfo;
    }
}

export class OrdersListResponse {
    constructor(data) {
        this.totalCount = data?.totalCount ?? 0;
        this.totalPages = data?.totalPages ?? 0;
        this.pageNumber = data?.pageNumber ?? 0;
        this.pageSize = data?.pageSize ?? 0;
        this.data = Array.isArray(data?.data)
            ? data.data.map((order) => new OrderList(order))
            : [];
    }

    getTotalCount() {
        return this.totalCount;
    }

    getTotalPages() {
        return this.totalPages;
    }

    getPageNumber() {
        return this.pageNumber;
    }

    getPageSize() {
        return this.pageSize;
    }

    getData() {
        return this.data;
    }
}
